// Imports for external libraries go here.
import { FC } from 'react';
import { UpgradeProps } from './Upgrade.types';
import { StyledUpgrade } from './Upgrade.styles';
import { sanitize } from '../../../../modules/utils/common';

// Use named rather than default exports.
export const Upgrade: FC<UpgradeProps> = ({ ppv5RTE }) => {
  const upgrade = sanitize(ppv5RTE ?? '');

  return (
    <StyledUpgrade data-testid="ppv5-Upgrade" data-component-name="o-ppv5-Upgrade" className="mt-4 pt-4 container">
      {upgrade && (
        <div
          data-testid="upgrade"
          dangerouslySetInnerHTML={{
            __html: upgrade,
          }}
        ></div>
      )}
    </StyledUpgrade>
  );
};
